import { mapValues, groupBy } from 'lodash';

export const nest = (seq, keys) => {
  if (!keys.length) return seq;
  const [first, ...rest] = keys;
  return mapValues(groupBy(seq, first), value => nest(value, rest));
};



// WEBPACK FOOTER //
// ./src/utils/nest.js